import React, { Suspense } from "react";
import { Switch, Route } from 'react-router-dom';
import Config from "../../config/config";
import { Layout, Button, Dropdown } from "antd";
import { MenuUnfoldOutlined, MenuFoldOutlined, UserOutlined, DownOutlined } from '@ant-design/icons';

import "./manage.scss";

const LeftMenu = React.lazy(() => import("./left-menu"));
const TplRender = React.lazy(() => import("../tpl/tpl-render"));
const Welcome = React.lazy(() => import("./welcome"));

const { Header, Content, Sider } = Layout;

export default class App extends React.PureComponent<any, any> {
    constructor(props: any) {
        super(props);

        this.state = { collapsed: false, username: '' };
    }

    componentDidMount(): void {
        this.setState({ username: Config.username });
    }

    public setCollapsed() {
        this.setState({ collapsed: !this.state.collapsed });
    }

    public userMenuClick(e: any) {
        switch (e.key) {
            case '1':
                this.props.history.push('/manage/apps/0c69cd85fbc745bbb888b2f3424b8ed4');
                break;
            case '2':
                Config.username = '';
                Config.token = '';
                localStorage.removeItem('token');
                this.props.history.push('/passport/login');
                break;
        }
    }

    render() {
        const { collapsed } = this.state;

        return <>
            <Layout className="layout">
                <Sider className="sider" trigger={null} collapsible collapsed={collapsed} theme="light">
                    <div className="logo">CMS</div>
                    <LeftMenu {...this.props} />
                </Sider>
                <Layout>
                    <Header className="header">
                        <div className="fold">
                            <Button
                                className="fold-btn"
                                type="text"
                                icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                                onClick={() => this.setCollapsed()}
                            />
                        </div>

                        <div className="nav">
                            nav
                        </div>

                        <div className="extra">
                            <UserOutlined />

                            <Dropdown menu={{
                                items: [
                                    { key: '1', label: (<a>设置密码</a>) },
                                    { key: '2', label: (<a>退出</a>) }
                                ],
                                onClick: (e) => this.userMenuClick(e),
                            }} placement="bottomRight">
                                <a onClick={(e) => e.preventDefault()}>
                                    <span className="user">{this.state.username}</span>
                                    <DownOutlined />
                                </a>
                            </Dropdown>
                        </div>
                    </Header>
                    <Content className="content">
                        <Suspense fallback={<div>Loading...</div>}>
                            <Switch>
                                <Route path="/manage/welcome" component={Welcome} />
                                <Route path="/manage/apps/:uuid" component={TplRender} />
                            </Switch>
                        </Suspense>
                    </Content>
                </Layout>
            </Layout>
        </>;
    }
}